import { NO_OP } from '../constants/Constants';
import { deepClone } from './helper';
import favicon from '../assets/images/TAP_Fav_Icon.png';

/**
 * @description BrowserNotification is a helper class to show Web Notifications.
 */
export class BrowserNotification {
  constructor() {
    var _this = this;
    /**
     * @description Function to Show notification.
     * @param {string} notificationTitle - Title of the Notification.
     * @param {string} notificationBody - Body of the Notification.
     * @param {boolean} notificationRequireInteraction - Whether user interaction is required for the Notification.
     * @param {object} notificationData - Data of the Notification.
     * @param {function} notificationOnClick - Callback function to be executed when Notification clicked.
     * @param {array} restNotificationOnClickParams - Params to be passed to Callback function when Notification clicked.
     * @return {object} - notification object.
     */
    this.showNotification = function () {
      let notificationTitle = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'Notification Title';
      let notificationBody = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'Notification Body';
      let notificationRequireInteraction = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      let notificationData = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
      let notificationOnClick = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : NO_OP;
      if (_this.isSupportNotification && _this.isPermissionGranted) {
        const notification = _this.createNotification(notificationTitle, notificationBody, notificationData, notificationRequireInteraction);
        for (var _len = arguments.length, restNotificationOnClickParams = new Array(_len > 5 ? _len - 5 : 0), _key = 5; _key < _len; _key++) {
          restNotificationOnClickParams[_key - 5] = arguments[_key];
        }
        _this.onClick(notification, notificationOnClick, restNotificationOnClickParams);
        _this.notifications.push(notification);
        return notification;
      }
      return {};
    };
    /**
     * @description Function to close notification.
     * @param {object} notificationObject - object returned from showNotification function call.
     * @return {boolean} - true if closed / false if not.
     */
    this.closeNotification = notificationObject => {
      if (this.isSupportNotification && this.isPermissionGranted) {
        const notifyObj = this.notifications.find(notification => notification.data.notification_id === notificationObject.data.notification_id);
        if (notifyObj) notifyObj.close();
        this.notifications = this.notifications.filter(notification => notification.data.notification_id !== notificationObject.data.notification_id);
        return true;
      }
      return false;
    };
    /**
     * @description Function to clear all notification.
     * @return {boolean} - true if all cleared / false if not clearing all notification .
     */
    this.clearAllNotifications = () => {
      if (this.isSupportNotification && this.isPermissionGranted) {
        this.notifications.forEach(notification => notification.close());
        return true;
      }
      return false;
    };
    // check if the browser supports notifications
    this.isSupportNotification = false;
    // check if the browser granted permission for notifications
    this.isPermissionGranted = false;
    this.notifications = [];
    this.errorLog = null;
    if ('Notification' in window) {
      const userPermission = Notification.permission;
      if (userPermission !== 'granted') {
        this.requestPermission();
      } else if (userPermission === 'granted') {
        this.isPermissionGranted = true;
      }
      this.isSupportNotification = true;
    }
  }

  /**
   * @description Helper Function to request permission from user.
   */
  requestPermission() {
    if (this.checkNotificationPromise()) {
      Notification.requestPermission().then(() => {
        if (Notification.permission === 'granted') {
          this.isPermissionGranted = true;
        }
      });
    } else {
      Notification.requestPermission(status => {
        if (status === 'granted') {
          this.isPermissionGranted = true;
        }
      });
    }
  }

  /**
   * @description Helper Function to check whether the browser supports the promise version of Notification.requestPermission().
   */
  checkNotificationPromise() {
    try {
      Notification.requestPermission().then();
    } catch (e) {
      return false;
    }
    return true;
  }

  /**
   * @description Helper Function to create notification.
   * @param {string} title - Title of the Notification.
   * @param {string} body - Body of the Notification.
   * @param {object} data - Data of the Notification.
   * @param {boolean} requireInteraction - Whether user interaction is required for the Notification.
   * @return {object} - Notification object.
   */
  createNotification(title, body, data, requireInteraction) {
    const notificationData = deepClone(data);
    notificationData.notification_id = new Date().getTime();
    const options = {
      body,
      data: notificationData,
      icon: favicon,
      requireInteraction
    };
    const notification = new Notification(title, options);
    return notification;
  }
  /**
   * @description Function to called when notification is clicked from user.
   * @param {object} notification -  Notification Object.
   * @param {function} notificationOnClick -  Notification onclick callback function.
   * @param {array} params -  Notification callback params.
   */
  onClick(notification, notificationOnClick, params) {
    const notifyObj = notification;
    notifyObj.onclick = function whenClicked() {
      try {
        window.focus();
        notificationOnClick(notifyObj, ...params);
        notifyObj.close();
      } catch (ex) {
        this.errorLog = ex;
        console.error('Error on click of notification', ex);
      }
    };
  }
}